var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "label",
    {
      staticClass: "btn w-100 btn-white",
      class: { active: _vm.appIsEnabled, disabled: _vm.app.disabled },
      on: {
        click: function ($event) {
          !_vm.app.disabled && _vm.$emit("toggle", _vm.app)
        },
      },
    },
    [
      _vm._v(" " + _vm._s(_vm.app.title) + " "),
      _vm.app.disabled
        ? _c("span", { staticClass: "badge bg-secondary-soft ms-1" }, [
            _vm._v("Coming soon"),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }